var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164.878,
    height: 47.983,
    viewBox: "0 0 164.878 47.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H49.67V18.875H0Z",
    transform: "translate(0.15 0.125)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_9",
    "data-name": "Clip 9",
    d: "M0,0H7.846V21.845H0Z",
    transform: "translate(0 0.018)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_14",
    "data-name": "Clip 14",
    d: "M0,0H138.794V39.837H0Z",
    transform: "translate(0.084 0.018)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0 -0.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(3 29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H49.67V18.875H0Z",
    transform: "translate(0.15 0.125)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M26.112,18.875a7.487,7.487,0,0,1-5.052-1.827,6.41,6.41,0,0,1-2.1-4.9V0h4.653V12.04a2.41,2.41,0,0,0,2.5,2.733,2.456,2.456,0,0,0,2.552-2.733V0h4.654V12.145a6.381,6.381,0,0,1-2.127,4.9A7.576,7.576,0,0,1,26.112,18.875ZM4.866,18.718H0L6.887,0h3.59l6.886,18.716H12.5L11.62,15.93H5.8l-.931,2.787ZM8.8,7.1l-1.7,5h3.3Zm36.216,11.62H40.364V4.1H35.71V0H49.67V4.1H45.017V18.716Z",
    transform: "translate(0.15 0.125)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M55.563,19H50.848V0h4.123l6.143,9.553V0h4.716V19H61.708L55.563,9.446V19ZM21.611,19H16.9V0h7.6a6.593,6.593,0,0,1,4.871,1.885,6.018,6.018,0,0,1,1.677,4.226,5.316,5.316,0,0,1-1,3.172,5.8,5.8,0,0,1-2.129,1.791L32.066,19H26.6l-3.4-7.071h-1.59V19Zm0-14.811V8.032h2.669a1.925,1.925,0,1,0,0-3.842ZM76.825,19H69.71V0h7.114A7.153,7.153,0,0,1,82,1.868c2.034,2.015,2.018,4.249,2,6.835,0,.261,0,.527,0,.8s0,.536,0,.8c.019,2.587.036,4.821-2,6.834A7.153,7.153,0,0,1,76.825,19Zm-2.4-14.837V14.836H76.5a2.482,2.482,0,0,0,2.264-1.067c.372-.526.512-1.03.512-4.269s-.14-3.745-.512-4.271A2.484,2.484,0,0,0,76.5,4.162ZM47.506,19H34.465V0H47.506V4.162H39.18V7.339h7.114V11.5H39.18v3.335h8.327V19ZM9.431,19H4.716V4.162H0V0H14.147V4.162H9.431V19Z",
    transform: "translate(74 29)",
    fill: "#F2971D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M9.5,19A9.5,9.5,0,1,1,19,9.5,9.511,9.511,0,0,1,9.5,19ZM9.626,4.345a5.244,5.244,0,1,0,5.26,5.243A5.257,5.257,0,0,0,9.626,4.345Z",
    transform: "translate(54 29)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_9-2",
    "data-name": "Clip 9",
    d: "M0,0H7.846V21.845H0Z",
    transform: "translate(0 0.018)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10-2",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M4.769,0A65.888,65.888,0,0,0,0,21.845S5.923,3.408,7.846.775C7.154.155,4.769,0,4.769,0",
    transform: "translate(0 0.018)",
    fill: "#F2971D"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    "data-name": "Fill 11",
    d: "M0,.409.306,4.6S29.409,1.03,47,5C36.277.021,15.516-.6,0,.409",
    transform: "translate(5 17)",
    fill: "#F2971D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_14-2",
    "data-name": "Clip 14",
    d: "M0,0H138.794V39.837H0Z",
    transform: "translate(0.084 0.018)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15-2",
    "data-name": "Group 15",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M138.291,27.867c-1.854-4.12-4.561-6.064-16.072-9.018S89,15.429,89,15.429,67.753.894,42.954.039,0,12.787,0,12.787C14.833,6.024,30.825.816,50.834,3.614S81.5,16.751,85.444,21.026c10.43-.233,27.426-.078,40.173,2.176s11.743,9.017,10.661,16.634c0,0,3.866-7.85,2.012-11.97",
    transform: "translate(0.084 0.018)",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb3a6104f7ea571262de54b3e4ff90f1.svg";
export { ForwardRef as ReactComponent };